import { useEffect } from "react";
import { IoClose } from "react-icons/io5";

export const Modal = ({
    open,
    onClose,
    title,
    children,
    width = "max-w-md",
}) => {
    // Prevent background scrolling when modal is open
    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [open]);

    // Handle Escape key to close
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") onClose();
        };
        if (open) window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4"
            role="dialog"
            aria-modal="true"
        >
            {/* Overlay */}
            <div
                className="fixed inset-0 bg-gray-500/30 backdrop-blur-sm"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div
                className={`relative bg-white w-full ${width} rounded-2xl shadow-xl p-6 transition-all transform animate-fadeIn z-10`}
            >
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                    <button
                        onClick={onClose}
                        className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-500 transition"
                        aria-label="Close modal"
                    >
                        <IoClose size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="max-h-[calc(100vh-12rem)] overflow-y-auto">
                    {children}
                </div>
            </div>
        </div>
    );
};
